const prefix = 'analyticscore@@'
export const WINDOW_SIZE_CHANGE = `${prefix}WINDOW_SIZE_CHANGE`
export const STORE_UNIT_MAP = `${prefix}STORE_UNIT_MAP`
export const STORE_UNIT_IDS = `${prefix}STORE_UNIT_IDS`
export const SET_UNIT_FUZZY_FILTER = `${prefix}SET_UNIT_FUZZY_FILTER`
export const STORE_ENTITY_API_URL = `${prefix}STORE_ENTITY_API_URL`
export const STORE_UNIT_GROUPS = `${prefix}STORE_UNIT_GROUPS`
export const SET_UNIT_GROUP_FILTER = `${prefix}SET_UNIT_GROUP_FILTER`
export const SET_FILTER_ADJUSTING = `${prefix}SET_FILTER_ADJUSTING`
export const SET_YEAR = `${prefix}SET_YEAR`
export const SET_ALL_UNITS = `${prefix}SET_ALL_UNITS`
export const SET_ALL_GROUPS = `${prefix}SET_ALL_GROUPS`
export const SET_SELECTED_UNITS = `${prefix}SET_SELECTED_UNITS`
export const SET_SELECTED_GROUPS = `${prefix}SET_SELECTED_GROUPS`
